import { render, staticRenderFns } from "./MostTradedSymbols.vue?vue&type=template&id=f0d29fc2&"
import script from "./MostTradedSymbols.vue?vue&type=script&lang=js&"
export * from "./MostTradedSymbols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports